import { useSelector } from "react-redux";
import { Colors } from "../../utils/colors";
import {
  COMPLIANCE_MESSAGE_DEFAULT,
  isApprovedPhoneStatus,
} from "@markit/common.utils";
import { getAccountSlice } from "../../redux/slices/accountSlice";
import { CSSProperties, useMemo } from "react";

// Matches the backend, move to Bit at some point.
// The preview text below mirrors the backend's buildPhonePromptCompliance wording exactly,
// a local duplicate here rather than a shared function for now.
const buildPhonePromptCompliance = (
  creatorName: string,
  isApproved: boolean
) => {
  return `By providing your number, you agree to receive recurring marketing texts sent by ${creatorName} ${
    isApproved
      ? "using an automated messaging platform"
      : "via Markit's automated messaging platform"
  }. ${COMPLIANCE_MESSAGE_DEFAULT}.`;
};

type PhoneComplianceTermsProps = {
  textStyles?: CSSProperties;
};

// Displays the compliance terms for the Instagram DM Automation phone-number prompt.
const PhoneComplianceTerms = (props: PhoneComplianceTermsProps) => {
  const { textStyles } = props;
  const accountData = useSelector(getAccountSlice).accountData;

  const styles = {
    urlButton: {
      backgroundColor: Colors.WHITE,
      border: `0.5px solid ${Colors.GRAY2}`,
      borderRadius: 4,
      padding: "4px 10px",
      width: 100,
      textAlign: "center" as const,
    },
  };

  const isApprovedPhone = useMemo(
    () => isApprovedPhoneStatus(accountData),
    [accountData]
  );

  return (
    <div className="ColumnNormal" style={{ gap: 7 }}>
      <span className="bodySmallRegular" style={textStyles}>
        {buildPhonePromptCompliance(accountData.fullName, isApprovedPhone)}
      </span>
      <div className="AlignedRow" style={{ gap: 4 }}>
        <div className="smallBodySubtext" style={styles.urlButton}>
          Terms of Use
        </div>
        <div className="smallBodySubtext" style={styles.urlButton}>
          Privacy Policy
        </div>
      </div>
    </div>
  );
};

export default PhoneComplianceTerms;
